import React from "react";
import { BsThreeDots } from "react-icons/bs";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";

function PageControl({ page, setPage, maxPage, nextPage, prevPage }) {
  const onPreviousPage = () => {
    if (prevPage) {
      prevPage();
    } else {
      if (page === 1) {
        setPage(maxPage);
      } else {
        setPage(page - 1);
      }
    }
  };

  const onNextPage = () => {
    if (nextPage) {
      nextPage();
    } else {
      if (page === maxPage) {
        setPage(1);
      } else {
        setPage(page + 1);
      }
    }
  };
  return (
    <div className="add-content">
      <div className="button-wrapper">
        <button className="page-nav-button" onClick={onPreviousPage}>
          <SlArrowLeft />
          {"\u00A0"}Prev
        </button>
        {page > 2 && maxPage > 3 && (
          <>
            <button
              className="page-button"
              onClick={() => {
                setPage(1);
              }}
            >
              {1}
            </button>
            <div className="three-dot">
              <BsThreeDots />
            </div>
          </>
        )}
        {page === maxPage && maxPage > 2 && (
          <button className="page-button" onClick={() => setPage(page - 2)}>
            {page - 2}
          </button>
        )}
        {page !== 1 && (
          <button className="page-button" onClick={onPreviousPage}>
            {page - 1}
          </button>
        )}
        <button className="page-button selected">{page}</button>
        {page !== maxPage && (
          <button className="page-button" onClick={onNextPage}>
            {page + 1}
          </button>
        )}
        {page === 1 && maxPage > 2 && (
          <button className="page-button" onClick={() => setPage(page + 2)}>
            {page + 2}
          </button>
        )}
        {page !== maxPage && maxPage > 3 && (
          <>
            <div className="three-dot">
              <BsThreeDots />
            </div>
            <button
              className="page-button"
              onClick={() => {
                setPage(maxPage);
              }}
            >
              {maxPage}
            </button>
          </>
        )}
        <button className="page-nav-button" onClick={onNextPage}>
          Next{"\u00A0"}
          <SlArrowRight />
        </button>
      </div>
    </div>
  );
}

export default PageControl;
